import { useState, useEffect, useCallback } from 'react'
import { supabase } from './supabase'

let avatarCache = {}
let listeners = []
let channelInitialized = false

function notifyListeners() {
  listeners.forEach(fn => fn({ ...avatarCache }))
}

function initChannel() {
  if (channelInitialized) return
  channelInitialized = true
  supabase.channel('profiles_ch')
    .on('postgres_changes', { event: '*', schema: 'public', table: 'profiles' }, ({ new: row }) => {
      if (row?.email) {
        avatarCache[row.email.toLowerCase()] = row.avatar_url || null
        notifyListeners()
      }
    })
    .subscribe()
}

export function useAvatars() {
  const [avatars, setAvatars] = useState({ ...avatarCache })

  useEffect(() => {
    listeners.push(setAvatars)

    if (Object.keys(avatarCache).length === 0) {
      supabase.from('profiles').select('email, avatar_url').then(({ data, error }) => {
        if (!error && data) {
          data.forEach(p => { if (p.avatar_url) avatarCache[p.email.toLowerCase()] = p.avatar_url })
          notifyListeners()
        }
      })
    }

    initChannel()

    return () => {
      listeners = listeners.filter(fn => fn !== setAvatars)
    }
  }, [])

  const getAvatar = useCallback((email) => {
    return avatars[email?.toLowerCase()] || null
  }, [avatars])

  const updateAvatar = useCallback(async (email, file, uploadToR2Fn) => {
    if (!file || !email) return null
    try {
      const ext = file.name.split('.').pop()
      const path = `avatars/${email.toLowerCase().replace('@', '_').replace('.', '_')}.${ext}`
      const url = await uploadToR2Fn(file, path)
      await supabase.from('profiles').upsert(
        [{ email: email.toLowerCase(), avatar_url: url, updated_at: new Date().toISOString() }],
        { onConflict: 'email' }
      )
      avatarCache[email.toLowerCase()] = url
      notifyListeners()
      return url
    } catch (err) {
      console.error('Avatar upload failed:', err)
      return null
    }
  }, [])

  return { getAvatar, updateAvatar }
}
